import * as React from "react";

export const SendIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  color = "#23252A",
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    color={color}
    {...rest}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.042"
      d="M11.826 16.891a.355.355 0 0 0 .663-.017l4.604-13.456a.351.351 0 0 0-.45-.45L3.187 7.57a.354.354 0 0 0-.017.664l5.616 2.252a1.42 1.42 0 0 1 .788.787zM16.667 3.333l-7.237 7.3"
    ></path>
  </svg>
);
